module.exports = __webpack_public_path__ + "static/media/createlink_selected.1e8f4d6a.svg";